import React from 'react';

import moment from 'moment';
import { NoticeTableCellProps } from './noticeTableCellTypes';
import NoticeTableCell from './NoticeTableCell';

export default function AdDeadlineCell({ row }: NoticeTableCellProps) {
  const { original } = row;
  return (
    <NoticeTableCell>
      {moment(original.firstpublicationdeadline).format('MM/DD/YYYY h:mm A')}
    </NoticeTableCell>
  );
}
